var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c560d23b0775fc07b00d1c7bee6a06957b528841"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["uplift-frontend@uplift-inc"]={id:"c560d23b0775fc07b00d1c7bee6a06957b528841"};
      